import { mergeParams } from '../common';

const ArcUI = window['arc-ui'];
const TinperNext = window.TinperNext;

const Message = {
  create (options: any) {
    if (ArcUI) {
      ArcUI.Toast.show(options)
    } else if (TinperNext) {
      TinperNext.Message.destroy()
      TinperNext.Message.create(options)
    }
  }
}

const Confirm = {
  create (options: any) {
    if (ArcUI) {
      ArcUI.Dialog.confirm(options)
    } else if (TinperNext) {
      TinperNext.Modal.confirm(options)
    }
  },
  promise (options: any) {
    if (ArcUI) {
      return ArcUI.Dialog.confirm(options);
    } else if (TinperNext) {
      return new Promise((resolve, reject) => {
        TinperNext.Modal.confirm({ ...options, resolve, reject })
      })
    }
  }
}

let newNotification: any;
TinperNext?.Notification?.newInstance({ position: 'bottomRight' }, (n: any) => { newNotification = n });
const Notice = {
  create (options: any) {
    if (ArcUI) {
      ArcUI.Toast.show(options)
    } else if (TinperNext) {
      newNotification.notice(options);
    }
  }
}

const Notification = {
  create (options: any) {
    if (ArcUI) {
      ArcUI.Toast.show(options)
    } else if (TinperNext) {
      TinperNext.Notification[options.color](options);
    }
  }
}

export const message = {
  success (options = {}) {
    Message.create(mergeParams({ color: "success" }, options));
  },
  danger (options = {}) {
    Message.create(mergeParams({ color: "danger" }, options));
  },
  info (options = {}) {
    Message.create(mergeParams({ color: "info" }, options));
  },
  warning (options = {}) {
    Message.create(mergeParams({ color: "warning" }, options));
  }
};

export const notice = (options = {}) => {
  Notice.create(mergeParams({ color: "success" }, options));
};

export const notification = {
  success (options = {}) {
    Notification.create(mergeParams({ color: "success" }, options, 'title'));
  },
  error (options = {}) {
    Notification.create(mergeParams({ color: "error" }, options, 'title'));
  },
  info (options = {}) {
    Notification.create(mergeParams({ color: "info" }, options, 'title'));
  },
  warning (options = {}) {
    Notification.create(mergeParams({ color: "warning" }, options, 'title'));
  }
};

export function confirm (options = {}) {
  if (options.onOk || options.onCancel) {
    Confirm.create(mergeParams({ title: lang.templateByUuid('UID:P_CORE-YNF-FE_1894FE9404500002', '确认') }, options));
  } else {
    return Confirm.promise(mergeParams({ title: lang.templateByUuid('UID:P_CORE-YNF-FE_1894FE9404500002', '确认') }, options));
  }
}
